module.exports = __webpack_public_path__ + "img/anatomy-types.dd768e38.svg";